import { IApplicationState } from '../../types/redux';

export function selectOfferChatAuthorId(state: IApplicationState): number | null | undefined {
  return state.chatModal.authorId;
}
